export default __webpack_public_path__ + "static/media/logistics.738b8507.png";